<template>
  <div class="fixed right-10 xl:right-4 bottom-4 text-white font-oswald leading-none flex flex-row items-center gap-4">
    <div
      v-if="leveling"
      class="rounded-lg text-2xl p-4 cursor-pointer font-oswald transition duration-300 border border-gray-roc bg-black hover:bg-gray-roc text-gray-200 leading-none"
      title="Level up to next era!"
      @click="levelUp"
    >
      <i class="fas fa-arrow-alt-circle-up"/>
    </div>
    <div
      class="rounded-lg text-2xl py-4 px-6 cursor-pointer transition duration-300 border border-gray-roc bg-black hover:bg-gray-roc"
      title="Lock uninhabited expansions"
      @click="lockExpansions"
    >
      <i class="fas fa-lock"/>
    </div>
    <div
      class="uppercase rounded-lg text-2xl py-4 px-8 cursor-pointer transition duration-300 border border-gray-roc bg-black hover:bg-gray-roc"
      @click="saveLayout"
    >
      Save
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leveling: {
      type: Boolean,
      required: true
    }
  },
  emits: ['levelUp', 'save', 'lockExpansions'],
  setup(_, context) {
    return {
      levelUp() {
        context.emit('levelUp');
      },
      saveLayout() {
        context.emit('save');
      },
      lockExpansions() {
        context.emit('lockExpansions');
      }
    };
  }
};
</script>
